import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = { class: "fs-15px fw-500 text-cool-gray-70 block q-ml-sm" }
const _hoisted_2 = { class: "flex items-center gap-12 q-pr-sm" }

import translate from 'src/common/helpers/language/translate'
import translationObject from './translate/availabilityTable.translate'
import { IAvailability, ITableColumn } from 'src/common/interfaces'
import { IBaseAvailabilityTableRow } from '../base/Availability/BaseAvailability/interfaces/baseAvailability.interface'

interface IProps {
  columns: ITableColumn[]
  rows: IBaseAvailabilityTableRow[]
  salesTypeToggle?: boolean
  availabilities?: IAvailability[]
}

interface IEmits {
  (event: 'view', availabilityId: number): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'AvailabilityTable' },
  __name: 'AvailabilityTable',
  props: {
    columns: {},
    rows: {},
    salesTypeToggle: { type: Boolean, default: false },
    availabilities: { default: () => [] }
  },
  emits: ["view"],
  setup(__props: any) {


const props = __props


const { t } = translate(translationObject)

return (_ctx: any,_cache: any) => {
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_k_checkbox = _resolveComponent("k-checkbox")!
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_k_dropdown = _resolveComponent("k-dropdown")!
  const _component_k_btn = _resolveComponent("k-btn")!
  const _component_k_table = _resolveComponent("k-table")!

  return (_openBlock(), _createBlock(_component_k_table, {
    columns: props.columns,
    rows: props.rows,
    class: _normalizeClass(["AvailabilityTable", { 'hide-header': props.salesTypeToggle }]),
    "root-class": "no-wrap",
    "has-footer": false,
    "is-selectable": false
  }, {
    body: _withCtx(({ localProps }) => [
      (localProps.rowIndex === 0 && !props.salesTypeToggle)
        ? (_openBlock(), _createBlock(_component_q_tr, {
            key: 0,
            class: "table-body-separator"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_td, {
                class: "separator",
                colspan: "100%"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("div", { class: "full-width" }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (props.rows.length)
        ? (_openBlock(), _createBlock(_component_q_tr, {
            key: 1,
            props: localProps
          }, {
            default: _withCtx(() => [
              (!props.salesTypeToggle)
                ? (_openBlock(), _createBlock(_component_q_td, {
                    key: 0,
                    class: "flex items-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_k_checkbox, {
                        modelValue: localProps.row.active,
                        "onUpdate:modelValue": ($event: any) => ((localProps.row.active) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      (localProps.row.icon)
                        ? (_openBlock(), _createBlock(_component_k_icon, {
                            key: 0,
                            name: localProps.row.icon,
                            color: "cool-gray-70"
                          }, null, 8, ["name"]))
                        : (_openBlock(), _createBlock(_component_k_icon, {
                            key: 1,
                            name: "sales-type",
                            color: "cool-gray-70"
                          })),
                      _createElementVNode("span", {
                        class: _normalizeClass(["fs-15px fw-500 block q-ml-sm", [localProps.row.active ? 'text-cool-gray-80' : 'text-cool-gray-70']])
                      }, _toDisplayString(localProps.row.salesType), 3)
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createBlock(_component_q_td, {
                    key: 1,
                    class: "flex items-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_k_icon, {
                        name: localProps.row.icon,
                        color: "cool-gray-70",
                        class: "q-ml-xs"
                      }, null, 8, ["name"]),
                      _createElementVNode("span", _hoisted_1, _toDisplayString(localProps.row.salesType), 1)
                    ]),
                    _: 2
                  }, 1024)),
              _createVNode(_component_q_td, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_k_dropdown, {
                      modelValue: localProps.row.availabilityId,
                      "onUpdate:modelValue": ($event: any) => ((localProps.row.availabilityId) = $event),
                      options: props.availabilities,
                      "options-mode": "label",
                      placeholder: _unref(t)('select_availability'),
                      "root-class": "flex-1",
                      disable: !localProps.row.active
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder", "disable"]),
                    _createVNode(_component_k_btn, {
                      icon: "eye",
                      model: "link",
                      "custom-color": !localProps.row.active ? 'cool-gray-50' : 'cool-gray-70',
                      "icon-size": "24px",
                      onClick: ($event: any) => (localProps.row.active && _ctx.$emit('view', localProps.row.availabilityId))
                    }, null, 8, ["custom-color", "onClick"])
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["props"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["columns", "rows", "class"]))
}
}

})